import { render, staticRenderFns } from "./DeleteFeeType.vue?vue&type=template&id=4a96c622&scoped=true"
import script from "./DeleteFeeType.vue?vue&type=script&lang=js"
export * from "./DeleteFeeType.vue?vue&type=script&lang=js"
import style0 from "./DeleteFeeType.vue?vue&type=style&index=0&id=4a96c622&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a96c622",
  null
  
)

export default component.exports